module.exports = __webpack_public_path__ + "img/canopy.8fbd8ed5.svg";